/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';

import { NavigationReducer, NavigationPage, NavigationReducerDataFilter } from '../../../../Redux/Reducers/NavigationReducer';
import { useAppDispatch, useAppSelector } from '../../../../Redux/Store/hooks';
import { CartItemHelper } from '../../../Data/CartItem';
import { Collection } from '../../../Data/Collection';

import imgSearch from '../../../../Resources/Images/search.svg';
import imgShop from '../../../../Resources/Images/shop.svg';
import imgUser from '../../../../Resources/Images/user.svg';
import { CatalogFileDisplayOptions, CatalogFileRoot } from '../../../../common/libraries/fileFormats/catalog/catalog';
import { ProfileReducer } from '../../../../Redux/Reducers/ProfileReducer';

type HeaderComponentParameters = {
  sourceData : CatalogFileRoot,
  filters : NavigationReducerDataFilter[],
  displayOptions : CatalogFileDisplayOptions,
  showLogin : (isShowLoginViewActive: boolean) => void
};

export function HeaderComponent({
  sourceData,
  filters,
  displayOptions,
  showLogin,
} : HeaderComponentParameters) {

  // Grab the dispatch hook from Redux
  const dispatch = useAppDispatch();

  // Grab the actions from Reducers
  const profileActions = ProfileReducer.actions;

  // From the store, get the strings
  const sessionToken = useAppSelector((state) => {
    return state.ProfileReducer.sessionToken;
  })!;

  // From the store, get the strings
  const strings = useAppSelector((state) => {
    return state.TextsReducer.strings;
  })!;

  // From the store, get the cart
  const cartItems = useAppSelector((state) => {
    return state.CartReducer.cartItems;
  });

  // From the store, get the environment settings
  const environmentSettings = useAppSelector((state) => {
    return state.EnvironmentSettingsReducer;
  });

  const { changeState } = NavigationReducer.actions;

  const [searchQuery, setSearchQuery] = useState('');

  const logoPath = environmentSettings.catalogInfoPath + displayOptions.logoImagePath;

  const numItemsInCart = cartItems.reduce(
    (result, item) => { return result + CartItemHelper.GetQuantity(item); },
    0,
  );

  const [isNavExpanded, setIsNavExpanded] = useState(false);

  const handleToggleClick = () => {
    setIsNavExpanded(!isNavExpanded);
  };

  const handleNavLinkClick = () => {
    setIsNavExpanded(false);
  };

  const loginDropdown = () => {
    return (
      sessionToken === '' ? (
        <button
          className="dropdown-item"
          type="button"
          onClick={() => {
            showLogin(true);
          }}
        >
          {strings.LOGIN_ACTION_LOGIN}
        </button>
      ) : (
        <>
          <div style={{
            height: '40px', fontSize: '12px', color: 'blue',
          }}
          >
            {sourceData.sourceData.channelEmail}
          </div>
          <button
            className="dropdown-item"
            type="button"
            onClick={() => {
              dispatch(profileActions.clearSessionToken());
            }}
          >
            {strings.SIGN_OUT_ACTION}
          </button>
        </>
      )
    );
  };

  return (
    <nav className="navbar header  navbar-light col-12">
      <div className="container-fluid">
        <button
          className="navbar-toggler collapsed"
          type="button"
          style={{
            position: 'absolute', maxWidth: '50px', top: '10px', left: '25px',
          }}
          onClick={handleToggleClick}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* CART AND PROFILE */}
        <div style={{
          position: 'absolute', minWidth: '100px', right: '25px',
        }}
        >
          <ul
            className="navbar-nav"
            style={{ marginBottom: '2px', marginTop: '2px', float: 'right' }}
          >
            <li className="nav-item">
              <button
                type="button"
                style={{ border: 'none' }}
                onClick={() => {
                  dispatch(
                    changeState({
                      page: NavigationPage.Order,
                      collection: '',
                      object: '',
                      filter: undefined,
                      searchQuery: undefined,
                    }),
                  );
                  handleNavLinkClick();
                }}
              >
                <div style={{
                  display: 'flex', alignItems: 'center', backgroundColor: 'white', padding: '3px',
                }}
                >
                  <img
                    src={imgShop}
                    alt="Shop Icon"
                    style={{ paddingRight: '10px' }}
                  />
                  {numItemsInCart > 0 && (
                  <div className="cartItemCount">{numItemsInCart}</div>
                  )}
                </div>
              </button>
            </li>
            {sourceData.sourceData.channelIsAuthenticationEnabled && (
            <li className="nav-item">
              <div className="dropdown btn-group">
                <button
                  data-bs-toggle="dropdown"
                  id="userDropdownMenu"
                  type="button"
                  data-bs-placement="left"
                  aria-expanded="false"
                  style={{ border: 'none' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                      src={imgUser}
                      alt="User Icon"
                      style={{ paddingRight: '10px' }}
                    />
                  </div>
                </button>
                <div className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdownMenu" style={{ width: '200px', textAlign: 'center' }}>
                  {loginDropdown()}
                </div>
              </div>
            </li>
            )}
          </ul>
        </div>
        {/* END CART AND PROFILE */}
        {/* LOGO */}
        <div className="row">
          <button
            type="button"
            className="navbar-brand"
            style={{ border: 'none', paddingLeft: '75px' }}
            onClick={() => {
              dispatch(
                changeState({
                  page: NavigationPage.Home,
                  collection: '',
                  object: '',
                  filter: undefined,
                  searchQuery: undefined,
                }),
              );
              handleNavLinkClick();
            }}
          >
            <img
              src={logoPath}
              alt="Home Icon"
              className="brand-image"
            />
          </button>
        </div>
        <div className={`collapse navbar-collapse justify-content-center ${isNavExpanded ? 'show' : ''}`}>
          <ul className="navbar-nav">
            {/* Predefined filters */}
            {filters.map((f, index) => {
              return (
                <li
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  className="nav-item"
                  style={{ paddingRight: '25px' }}
                >
                  <button
                    type="button"
                    className="nav-link active"
                    aria-current="page"
                    style={{ border: 'none' }}
                    onClick={() => {
                      dispatch(
                        changeState({
                          page: NavigationPage.Collection,
                          collection: Collection.AllCollections,
                          object: '',
                          filter: f,
                          searchQuery: undefined,
                        }),
                      );
                    }}
                  >
                    <h2>{f.name}</h2>
                    <hr />
                  </button>
                </li>
              );
            })}

            {/* All Collections / Items */}
            <li className="nav-item">
              <button
                type="button"
                className="nav-link active"
                style={{ border: 'none' }}
                aria-current="page"
                onClick={() => {
                  dispatch(
                    changeState({
                      page: NavigationPage.Collection,
                      collection: Collection.AllCollections,
                      object: '',
                      filter: undefined,
                      searchQuery: undefined,
                    }),
                  );
                  handleNavLinkClick();
                }}
              >
                <h2>{strings.PRODUCTLIST}</h2>
                <hr />
              </button>
            </li>
          </ul>
        </div>
        <div
          className={`collapse navbar-collapse justify-content-end ${isNavExpanded ? 'show' : ''}`}
          style={{ flexGrow: '0' }}
        >
          {/* SEARCH */}
          <div className="input-group">
            <div className="form-outline">
              <form
                onSubmit={(event) => {
                  event.preventDefault();
                  dispatch(
                    changeState({
                      page: NavigationPage.Search,
                      collection: '',
                      object: '',
                      filter: undefined,
                      searchQuery,
                    }),
                  );
                  setSearchQuery('');
                }}
              >
                <input
                  type="search"
                  value={searchQuery}
                  id="form1"
                  className="form-control rounded"
                  placeholder={strings.SEARCH_HEADER_LABEL}
                  aria-label="Search"
                  aria-describedby="search-addon"
                  onChange={(event) => {
                    setSearchQuery(event.target.value);
                  }}
                />
              </form>
            </div>
            <div style={{ width: '10px' }} />
            <button type="button" style={{ border: 'none' }}>
              <img
                src={imgSearch}
                alt="Search Icon"
                style={{ paddingRight: '10px' }}
                onClick={() => {
                  dispatch(
                    changeState({
                      page: NavigationPage.Search,
                      collection: '',
                      object: '',
                      filter: undefined,
                      searchQuery,
                    }),
                  );
                  setSearchQuery('');
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
